const dietRatioTextList = [
  {
    title: '饮食分量',
    type: '',
    list: [
      {
        id: '饮食分量',
        title: '饮食分量【偏少】',
        text: '饮食分量偏少易造成营养元素摄入不足。正餐分量偏少的情况，容易因为饥饿感而极度渴望高热量食物，建议餐食遵循七分饱的原则，在出现饥饿感时，补充低糖水果或蛋白质含量丰富的食物。入营后请及时与您的营养师建立联系，将整体分量调整至最佳状态。',
        zIndex: 4
      },
      {
        id: '饮食分量',
        title: '饮食分量【适中】',
        text: '',
        zIndex: 4
      },
      {
        id: '饮食分量',
        title: '饮食分量【偏多】',
        text: '长时间的饮食分量偏多，容易因能量过剩造成身体的肥胖。保证身体基本能量摄入的同时避免过度饮食。入营后请及时与您的营养师建立联系，将整体分量调整至最佳状态。',
        zIndex: 4
      }
    ]
  },
  {
    title: '主食比例',
    list: [
      {
        id: '主食比例',
        title: '主食比例【偏少】',
        text: '主食主要为身体提供碳水化合物，是最经济的身体能量摄入来源。摄入过少时容易造成注意力不集中、烦燥不安等情况。入营后请及时与您的营养师建立联系，将主食增加至适合的分量。',
        zIndex: 3
      },
      {
        id: '主食比例',
        title: '主食比例【适中】',
        text: '主食的摄入适中，可以在满足身体所需的情况下，不影响其它营养元素的吸收，非常棒，继续加油！',
        zIndex: 3
      },
      {
        id: '主食比例',
        title: '主食比例【偏多】',
        text: '主食主要为身体提供碳水化合物，是最经济的身体能量摄入来源。但摄入过多时会以脂肪的形式在身体中囤积，还会影响到蛋白质蔬菜的摄入比例。入营后请及时与您的营养师建立联系，将主食调整至适合的分量。',
        zIndex: 3
      }
    ]
  },
  {
    title: '蛋白质比例',
    list: [
      {
        id: '蛋白质比例',
        title: '蛋白质比例【偏少】',
        text: '蛋白质摄入不足时，容易出现胶原蛋白流失，营养不良性水肿，视觉上看人更显胖。建议蛋白质的摄入多以优质蛋白质为主，各类优质蛋白质食物（肉奶蛋豆）配比多样化。入营后请及时与您的营养师建立联系，将蛋白质增加至适合的分量。',
        zIndex: 2
      },
      {
        id: '蛋白质比例',
        title: '蛋白质比例【适中】',
        text: '蛋白质的摄入适中，基本在满足身体所需的营养，建议在营养师的指导下适量的增加辅助运动，增加身体的肌肉占比。',
        zIndex: 2
      },
      {
        id: '蛋白质比例',
        title: '蛋白质比例【偏多】',
        text: '蛋白质摄入过量，也会伴随脂肪摄入增高，导致热量摄入超标，最终会转换成脂肪在身体堆积。入营后请及时与您的营养师建立联系，将蛋白质调整至适合的分量。',
        zIndex: 2
      }
    ]
  },
  {
    title: '蔬菜比例',
    list: [
      {
        id: '蔬菜比例',
        title: '蔬菜比例【偏少】',
        text: '虽然蔬菜的热量较低，但维生素和膳食纤维含量较高。如果膳食纤维不够，会影响肠道蠕动出现便秘、肠道有益菌种减少，影响肠道糖脂吸收。\n建议蔬菜的摄入每天控制在350-500g左右，且绿叶蔬菜占到蔬菜总摄入量的一半以上，蔬菜种类多样化，多食用当季的蔬菜。入营后请及时与您的营养师建立联系，将蔬菜调整至适合的分量。',
        zIndex: 1
      },
      {
        id: '蔬菜比例',
        title: '蔬菜比例【适中】',
        text: '蔬菜摄入适中，既保证了膳食纤维和维生素、矿物质的吸收，也增加了食物摄入的多样化，非常棒，继续加油！',
        zIndex: 1
      },
      {
        id: '蔬菜比例',
        title: '蔬菜比例【偏多】',
        text: '虽然蔬菜的热量较低，但蔬菜摄入偏多时，容易影响主食蛋白质脂肪的摄入量，造成整体能量偏低，建议蔬菜的摄入每天控制在350-500g左右，且绿叶蔬菜占到蔬菜总摄入量的一半以上。入营后请及时与您的营养师建立联系，将蔬菜调整至适合的分量。',
        zIndex: 1
      }
    ]
  }
]
//根据选择特点的建议列表
const featuresTextList = {
  24: {
    id: 24,
    title: '重油重盐',
    text: '从您的日常餐卡图片观察到，您目前的饮食结构存在【重油重盐】\n油脂摄入过多不仅会增加热量的摄入，同时油脂中的饱和脂肪摄入过多，还会加大患心血管疾病的风险；\n盐摄入过量不仅引发身体水肿，还会提高身体对糖类物质的吸收利用率，从而增加肥胖风险。',
    zIndex: 6
  },
  25: {
    id: 25,
    title: '油脂不足',
    text: '从您的日常餐卡图片观察到，您目前的饮食结构存在【油脂不足】\n油脂身体必需脂肪的摄入主要来源于食用油脂，摄入不足时会影响食物中脂溶性维生素吸收不均衡而导致营养不良。\n中国居民膳食指南建议：成人每天油脂摄入为25-30g、盐的摄入6g以内',
    zIndex: 6
  }
}
export { dietRatioTextList, featuresTextList }
